// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorFallback_wrapper__1x4_l"};